const EDITOR_PATH_PATTERNS = [
  /\/workspace\/patients\/[^/]+\/session-notes\/[^/]+/,
  /\/workspace\/patients\/[^/]+\/first-consultation\/[^/]+/,
  /\/workspace\/patients\/[^/]+\/treatment-plan\/[^/]+/,
  /\/workspace\/announcements\/new/,
  /\/workspace\/intake\/[^/]+/,
];

export interface AssistantPageState {
  pathname: string;
  search: string;
  hasEdits: boolean;
  openFormHasUnsavedChanges: boolean | null;
}

export function isOnEditorPage(pathname: string): boolean {
  return EDITOR_PATH_PATTERNS.some(function matches(pattern) {
    return pattern.test(pathname);
  });
}

export function hasOpenDialog(root: ParentNode): boolean {
  return root.querySelector('[role="dialog"]:not([data-assistant-panel])') !== null;
}

export function leavesCurrentScreen(page: AssistantPageState, targetPath: string): boolean {
  return targetPath !== page.pathname + page.search;
}

export function isWorkAtRisk(page: AssistantPageState, root: ParentNode): boolean {
  if (page.openFormHasUnsavedChanges !== null) {
    return page.openFormHasUnsavedChanges || hasOpenDialog(root);
  }
  return page.hasEdits || hasOpenDialog(root) || isOnEditorPage(page.pathname);
}

export function canNavigateAutomatically(
  page: AssistantPageState,
  targetPath: string,
  root: ParentNode
): boolean {
  if (leavesCurrentScreen(page, targetPath) === false) {
    return true;
  }
  return isWorkAtRisk(page, root) === false;
}
